import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CRYPTO_LYZI } from '../../../../constants/paymentMethods';
import { APPLICATION_SPECIFIC_STATIC_ROOT } from '../../../../constants';

import { CryptoLyziContainer } from './CryptoLyziStyle';

const CryptoLyzi = ({ selectedMethod, handleMethodChange, i18n }) => {
    return (
        <CryptoLyziContainer onClick={() => handleMethodChange(CRYPTO_LYZI)}>
            <div>
                <input
                    type="radio"
                    id="lyzi"
                    name="lyzi"
                    value={CRYPTO_LYZI}
                    checked={selectedMethod === CRYPTO_LYZI}
                />

                <label htmlFor="lyzi">
                    <img
                        src={`${APPLICATION_SPECIFIC_STATIC_ROOT}/lyzi-picto.png`}
                        alt="crypto-logos"
                        width="25"
                        height="20"
                    />
                    {i18n.PAYMENT_CHOICE.CRYPTO_LYZI}
                </label>
            </div>
            <div>
                <img
                    src={`${APPLICATION_SPECIFIC_STATIC_ROOT}/crypto.png`}
                    alt="crypto-logos"
                    width="100"
                    height="30"
                />
            </div>
        </CryptoLyziContainer>
    );
};

CryptoLyzi.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(CryptoLyzi);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CryptoLyzi.js